function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-trash-alt",
  "data-name": "Icon awesome-trash-alt",
  d: "M1.643,23.821a2.464,2.464,0,0,0,2.464,2.464H18.893a2.464,2.464,0,0,0,2.464-2.464V6.571H1.643ZM15.607,10.679a.821.821,0,1,1,1.643,0v11.5a.821.821,0,0,1-1.643,0Zm-4.929,0a.821.821,0,0,1,1.643,0v11.5a.821.821,0,0,1-1.643,0Zm-4.929,0a.821.821,0,0,1,1.643,0v11.5a.821.821,0,0,1-1.643,0ZM22.179,1.643H16.018l-.483-.96A1.232,1.232,0,0,0,14.431,0H8.563a1.218,1.218,0,0,0-1.1.683l-.483.96H.821A.821.821,0,0,0,0,2.464V4.107a.821.821,0,0,0,.821.821H22.179A.821.821,0,0,0,23,4.107V2.464A.821.821,0,0,0,22.179,1.643Z",
  transform: "translate(0.5 0.5)",
  fill: "none",
  stroke: "#102655",
  strokeWidth: 1
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27.286,
    viewBox: "0 0 24 27.286",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.3c5bef28.svg";
export { ForwardRef as ReactComponent };